import { AngularFirestoreDocument } from "@angular/fire/firestore"
import { FirebaseService } from "./firebase.service"

export abstract class FirebaseCollectionBase<T = any> {
  public abstract getId: (item: any) => string

  public data: T[] = []
  public dataMap: { [id: string]: T } = {}

  constructor(
    protected firebaseService: FirebaseService,
  ) {}

  public toMap(): { [id: string]: T } {
    this.dataMap = {}
    this.data.forEach(test => this.dataMap[this.getId(test)] = test)
    return this.dataMap
  }
}

export abstract class FirebaseDocumentBase<T = any> {
  public data: T

  public abstract getDocument(): AngularFirestoreDocument<T>

  constructor(
    protected firebaseService: FirebaseService,
  ) {}

  public async getData(): Promise<T> {
    const documentSnapshot = await this.getDocument().ref.get()
    const documentData = documentSnapshot.exists ? documentSnapshot.data() as T : null
    this.data = documentData
    return this.data
  }

  public async update(updateObj: any): Promise<any> {
    return this.getDocument().update(updateObj)
  }
}
